import styled, { css } from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';

export const SCALLOP_SIZE = 16;
export const DEFAULT_COLOR = Colors.WHITE;

export const Edge = styled.div<{ color?: Colors }>`
  height: ${SCALLOP_SIZE}px;
  width: 100%;
  position: relative;
  margin-top: -${SCALLOP_SIZE - 1}px;
  margin-bottom: -4px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    left: -${SCALLOP_SIZE}px;
    right: 0;
    height: ${SCALLOP_SIZE}px;
    background-size: ${SCALLOP_SIZE * 2}px ${SCALLOP_SIZE}px !important;
    background-repeat: repeat-x !important;
  }

  ${({ color }) => css`
    &:before {
      background: radial-gradient(
        closest-side,
        ${color ?? DEFAULT_COLOR},
        ${color ?? DEFAULT_COLOR} 55%,
        transparent 55%
      );
      background-position: 0 1px;
      bottom: 0;
    }

    &:after {
      background: radial-gradient(closest-side, transparent, transparent 55%, ${color ?? DEFAULT_COLOR} 55%);
      background-position: ${SCALLOP_SIZE}px -${SCALLOP_SIZE / 2 + 2}px;
      bottom: -${SCALLOP_SIZE / 2 - 1}px;
    }
  `}
`;

export const FlippedEdge = styled(Edge)`
  transform: rotateX(180deg) translateY(4px);
  margin-top: -3px;
  margin-bottom: -${SCALLOP_SIZE - 2}px;
`;
